import React from 'react';

import { ReactComponent as CheckBox } from '../../../../assets/novosicones/Renegociacao/check_box_outline_blank_black_24dp.svg';
import { ReactComponent as CheckBoxChecked } from '../../../../assets/novosicones/Renegociacao/check_box_black_24dp.svg';

import { CheckBoxContainer } from './styles';

const LiConcordo = ({ tema, handleConcordo, concordo }) => {
  return (
    <CheckBoxContainer>
      {!concordo && (
        <CheckBox
          onClick={handleConcordo}
          style={{ fill: '#4d4d4d' }}
          id={'checkBoxConcordoRenegociacao'}
        />
      )}
      {concordo && (
        <CheckBoxChecked
          onClick={handleConcordo}
          style={{ fill: tema.primaryColor }}
        />
      )}
      <p
        onClick={handleConcordo}
        className='checkBoxText'
        style={{ color: concordo ? tema.primaryColor : '#4d4d4d' }}
      >
        Eu li, e estou ciente das condições de pagamento
      </p>
    </CheckBoxContainer>
  );
};

export default LiConcordo;
